import './Home.css';
import { useNavigate } from 'react-router-dom';
import { FaLinkedin, FaFacebook, FaEnvelope } from 'react-icons/fa';
import profileImage from '../JASMIN.png';
import frontCover from '../cover/FRONT.jpg';

function Home() {
  const navigate = useNavigate();

  const scrollToAbout = () => {
    navigate('/about');
  };

  return (
    <>
      {/* ===== COVER SECTION ===== */}
      <div className="home-cover">
        <img src={frontCover} alt="Portfolio Cover" className="home-cover-img" />
        <div className="home-cover-overlay"></div>
        <div className="home-cover-content">
          <p className="home-cover-eyebrow">Welcome to</p>
          <h1 className="home-cover-title">MY PORTFOLIO</h1>
          <div className="home-cover-line"></div>
        </div>
        <div className="home-cover-scroll">
          <div className="home-cover-mouse"></div>
          <span>Scroll to explore</span>
        </div>
      </div>

      {/* ===== EXISTING HOME CONTENT ===== */}
      <section className="home">
      <div className="home-container">
        <div className="home-content">
          <h1 className="home-title">Jasmin Meghan<br/>R. Malolos</h1>
          <h2 className="home-subtitle">
            Computer Engineering Student <span className="divider">|</span> 
            <span className="highlight"> Aspiring Software Developer</span>
          </h2>
          <p className="home-tagline">
            3rd Year – Bachelor of Science in Computer Engineering<br/>
            <span className="school-name">FAITH Colleges</span>
          </p>
          <p className="home-description">
            A passionate Computer Engineering student dedicated to developing innovative solutions through technology. 
            With a growing foundation in both hardware and software systems, I continuously explore new tools, 
            programming practices, and engineering concepts to build efficient and meaningful digital solutions.
          </p>
          <div className="home-buttons">
            <button className="btn btn-primary" onClick={scrollToAbout}>
              Learn More About Me
            </button>
            <button className="btn btn-secondary" onClick={() => navigate('/resume')}>Resume</button>
          </div>
          <div className="social-links">
            <a href="https://www.linkedin.com/in/jasmin-meghan-malolos-2783333b7?utm_source=share_via&utm_content=profile&utm_medium=member_ios" target="_blank" rel="noopener noreferrer" className="social-icon" title="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="https://www.facebook.com/jasminmeghan.malolos?mibextid=wwXIfr&rdid=Rs1FcHyLUSqbCirX&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1E4tzGcH33%2F%3Fmibextid%3DwwXIfr" target="_blank" rel="noopener noreferrer" className="social-icon" title="Facebook">
              <FaFacebook />
            </a>
          </div>
        </div>
        <div className="home-image">
          <img src={profileImage} alt="Jasmin Meghan R. Malolos" className="profile-img"/>
        </div>
      </div>
    </section>
    </>
  );
}

export default Home;
